import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Centralised SEO component — handles title, meta, OG, Twitter, and JSON-LD.
 *
 * @param {string} title          full page title (will be appended with " — InfoPoint Albania" unless absolute=true)
 * @param {string} description    meta description (~155 chars)
 * @param {string} canonical      canonical path (e.g. "/albania/saranda")
 * @param {string} image          OG image URL (absolute or relative)
 * @param {object|array} jsonLd   structured data
 */
export const SEO = ({
  title,
  description,
  canonical,
  image = '/og-image.jpg',
  keywords,
  jsonLd,
  absolute = false,
  type = 'website',
}) => {
  const fullTitle = absolute ? title : `${title} — InfoPoint Albania`;
  const url = canonical ? `https://infopointalbania.al${canonical}` : 'https://infopointalbania.al/';
  const safeImage = image || '/og-image.jpg';
  const ogImage = safeImage.startsWith('http') ? safeImage : `https://infopointalbania.al${safeImage}`;
  const structured = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {structured.map((item, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(item)}</script>
      ))}
    </Helmet>
  );
};
